function FileCrossIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3536 11.1464C11.1583 10.9512 10.8417 10.9512 10.6464 11.1464C10.4512 11.3417 10.4512 11.6583 10.6464 11.8536L11.7929 13L10.6464 14.1464C10.4512 14.3417 10.4512 14.6583 10.6464 14.8536C10.8417 15.0488 11.1583 15.0488 11.3536 14.8536L12.5 13.7071L13.6464 14.8536C13.8417 15.0488 14.1583 15.0488 14.3536 14.8536C14.5488 14.6583 14.5488 14.3417 14.3536 14.1464L13.2071 13L14.3536 11.8536C14.5488 11.6583 14.5488 11.3417 14.3536 11.1464C14.1583 10.9512 13.8417 10.9512 13.6464 11.1464L12.5 12.2929L11.3536 11.1464Z"
        fill="#323232"
      />
      <path
        d="M18.5 18V8.5L14 4H8.5C7.39543 4 6.5 4.89543 6.5 6V18C6.5 19.1046 7.39543 20 8.5 20H16.5C17.6046 20 18.5 19.1046 18.5 18ZM14 7C14 7.82843 14.6716 8.5 15.5 8.5H17.5V18C17.5 18.5523 17.0523 19 16.5 19H8.5C7.94772 19 7.5 18.5523 7.5 18V6C7.5 5.44772 7.94772 5 8.5 5H14V7Z"
        fill="#323232"
      />
    </svg>
  );
}

export default FileCrossIcon;
